import { buttonCompoundVariants, buttonDefaultVariants, buttonDisabledVariants, buttonEmphasisVariants, buttonFullWidthVariants, buttonShadowVariants, buttonSizeVariants, buttonSlots, buttonTypeVariants } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const buttonVariants = tv({
    slots: buttonSlots,
    variants: {
        type: buttonTypeVariants,
        size: buttonSizeVariants,
        emphasis: buttonEmphasisVariants,
        fullWidth: buttonFullWidthVariants,
        shadow: buttonShadowVariants,
        disabled: buttonDisabledVariants
    },
    compoundVariants: buttonCompoundVariants,
    defaultVariants: buttonDefaultVariants
});
export { buttonVariants };
